<template>
  <div>
    <div id="captcha">
      <v-btn
        id="refresh-btn"
        rounded
        size="x-small"
        color="primary"
        @click="onRefreshClicked()"
      >
        <v-img
          class="control-button-image"
          :src="enterChatView.refreshBtnIconLink"
        ></v-img>
        Refresh
      </v-btn>
      <canvas ref="canvas" style="width:100%; max-width: 350px; height:80px">
      </canvas>
      <div class="controls">
        <v-text-field
          variant="outlined"
          class="enter-chat-input-style"
          density="default"
          height="40"
          :disabled="isCaptchaPassed"
          :clearable="true"
          :clear-icon="isCaptchaPassed ? 'done' : ''"
          @click:clear="validate()"
          v-model="userText"
          color="#fff"
          :label="
            enterChatView.captchaInputText
              ? enterChatView.captchaInputText
              : 'Please Type here Captcha text..'
          "
          @keyup="validate()"
          autocomplete="off"
        >
        </v-text-field>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { watch } from "vue";
export default {
  name: "Captcha",
  data() {
    return {
      // possibleCharacters:   "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz123456789",
      possibleCharacters: "ABCDabcd2345",
      randomText: true,
      text: null,
      userText: null,
      randomColours: true,
      width: 300,
      height: 163,
      colour1: null,
      colour2: null,
      font: 'normal 40px "David", cursive, sans-serif',
      canvasContent: null,
      context: null,
      captchaInterval: null,
    };
  },
  computed: {
    ...mapGetters(["enterChatView", "isCaptchaPassed"]),
  },
  methods: {
    generate() {
      this.userText = "";
      this.context = this.$refs.canvas.getContext("2d");
      this._generateRandomText();

      if (this.randomColours) {
        this.colour1 = this._generateRandomColour();
        this.colour2 = this._generateRandomColour();
      }

      let gradient1 = this.context.createLinearGradient(0, 0, this.width, 0);
      gradient1.addColorStop(0, this.colour1);
      gradient1.addColorStop(1, this.colour2);

      this.context.fillStyle = gradient1;
      this.context.fillRect(0, 0, this.width, this.height);

      this.context.fillStyle = "rgba(255,255,255,0.65)";
      this.context.fillRect(0, 0, this.width, this.height);

      let gradient2 = this.context.createLinearGradient(0, 0, this.width, 0);
      gradient2.addColorStop(0, this.colour2);
      gradient2.addColorStop(1, this.colour1);

      this.context.font = this.font;
      this.context.fillStyle = gradient2;

      this.context.setTransform(
        Math.random() / 10 + 0.9, //scalex
        0.1 - Math.random() / 5, //skewx
        0.1 - Math.random() / 5, //skewy
        Math.random() / 10 + 0.9, //scaley
        Math.random() * 20 + 10, //transx
        100
      ); //transy

      this.context.fillText(this.text, 0, 0);

      this.context.setTransform(1, 0, 0, 1, 0, 0);

      let numRandomCurves = Math.floor(Math.random() * 3 + 5);

      for (let i = 0; i < numRandomCurves; i++) {
        this._drawRandomCurve();
      }
    },
    validate() {
      if (this.userText === this.text) {
        clearInterval(this.captchaInterval);
        this.onSuccess();
      } else {
        this.onFailure();
      }
    },
    _drawRandomCurve() {
      let ctx = this.context;

      let gradient1 = ctx.createLinearGradient(0, 0, this.width, 0);
      gradient1.addColorStop(
        0,
        Math.random() < 0.5 ? this.colour1 : this.colour2
      );
      gradient1.addColorStop(
        1,
        Math.random() < 0.5 ? this.colour1 : this.colour2
      );

      ctx.lineWidth = Math.floor(Math.random() * 4 + 2);
      ctx.strokeStyle = gradient1;
      ctx.beginPath();
      ctx.moveTo(
        Math.floor(Math.random() * this.width),
        Math.floor(Math.random() * this.height)
      );
      ctx.bezierCurveTo(
        Math.floor(Math.random() * this.width),
        Math.floor(Math.random() * this.height),
        Math.floor(Math.random() * this.width),
        Math.floor(Math.random() * this.height),
        Math.floor(Math.random() * this.width),
        Math.floor(Math.random() * this.height)
      );
      ctx.stroke();
    },
    _generateRandomText() {
      this.text = "";
      let length = Math.floor(Math.random() * 3 + 3);
      for (let i = 0; i < length; i++) {
        this.text += this.possibleCharacters.charAt(
          Math.floor(Math.random() * this.possibleCharacters.length)
        );
      }
    },
    onRefreshClicked() {
      clearInterval(this.captchaInterval);
      this.generate();
      this.captchaInterval = setInterval(this.generate, 15000);
    },
    _generateRandomColour() {
      return (
        "rgb(" +
        Math.floor(Math.random() * 255) +
        ", " +
        Math.floor(Math.random() * 255) +
        ", " +
        Math.floor(Math.random() * 255) +
        ")"
      );
    },
    onFailure() {
      this.$store.commit("setCaptchaPassed", false);
    },
    onSuccess() {
      this.$store.commit("setCaptchaPassed", true);
    },
  },
  mounted() {
    this.generate();
    this.captchaInterval = setInterval(this.generate, 15000);
    watch(this.isCaptchaPassed, (newVal, oldVal) => {
      //only if captcha not passed generate new one.
      if (newVal === false) {
        //settimout wait for mount canvas
        setTimeout(() => {
          this.generate();
        }, 0);
      }
    });
  },
};
</script>

<style scoped>
.control-button-image {
  max-width: 25px;
}
</style>
